import { HStack } from '@/components/ui/hstack';
import { Link, LinkText } from '@/components/ui/link';
import { Text } from '@/components/ui/text';

interface NeedHelpLinkProps {
  showNeedHelpText?: boolean;
  onPress: () => void;
  textSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export function NeedHelpLink({
  showNeedHelpText = false,
  onPress,
  textSize = 'md',
}: NeedHelpLinkProps) {
  return (
    <HStack space="xs">
      {showNeedHelpText && <Text size={textSize}>Need help?</Text>}
      <Link onPress={onPress}>
        <LinkText size={textSize} className="text-primary-500 data-[hover=true]:text-primary-600">
          Contact Support
        </LinkText>
      </Link>
    </HStack>
  );
}
